import React from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line import/no-cycle
import StyledContent from 'components/StyledContent';

import styles from './styles.module.scss';

const AnswerBlock = ({ content }) => (
	<div className={styles.AnswerBlock}>
		<StyledContent blocks={content} firstParagraph={false} />
	</div>
);

AnswerBlock.propTypes = {
	content: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired
};

export default AnswerBlock;
